import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import sprintf from 'i18next-sprintf-postprocessor';
import HttpBackend from 'i18next-http-backend';
import { locales } from '../../../../scripts/translations/locales';

export { locales };

// Custom path detector that redirects fil-PH to tl-PH
const customPathDetector = {
  name: 'customPath',
  lookup() {
    const path = window.location.pathname;
    // Match both 'es' and 'es-MX' format locales
    const localeMatch = path.match(/^\/([a-z]{2,3}(?:-[A-Z]{2})?)\//);
    if (localeMatch) {
      const detectedLocale = localeMatch[1];
      // If fil-PH is detected in URL, redirect to tl-PH
      if (detectedLocale === 'fil-PH') {
        const newPath = path.replace('/fil-PH/', '/tl-PH/');
        window.history.replaceState(null, '', newPath + window.location.search + window.location.hash);
        return 'tl-PH';
      }
      return detectedLocale;
    }
    return localStorage.getItem('i18nextLng') || 'en';
  },
};

const detectedLang = customPathDetector.lookup();

i18n
  // Don't use languageDetector during init since we're setting lng explicitly
  .use(sprintf)
  .use(HttpBackend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: detectedLang || 'en', // Explicitly set the detected language
    fallbackLng: 'en',
    partialBundledLanguages: true,
    initImmediate: false, // Make initialization synchronous
    languages: locales,
    ns: ['common', 'reactifi'],
    defaultNS: 'common',
    fallbackNS: ['common', 'reactifi'],
    keySeparator: '>',
    react: {
      useSuspense: true,
    },
    nsSeparator: '|',
    returnObjects: true,
    returnEmptyString: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: ',',
      format: function (value, format) {
        if (format === 'uppercase') return value.toUpperCase();
        return value;
      },
    },
    backend: {
      loadPath: (languages, namespaces) => {
        // Map fil-PH to tl-PH for file loading (they share translation files)
        const lng = languages[0] === 'fil-PH' ? 'tl-PH' : languages[0];
        return `/locales/${namespaces[0]}/${lng}/translations.json`;
      },
    },
  });

// Proxy to convert fil-PH to tl-PH when accessing i18n.language
const i18nProxy = new Proxy(i18n, {
  get(target, prop) {
    if (prop === 'language') {
      const lang = target.language;
      return lang === 'fil-PH' ? 'tl-PH' : lang;
    }
    const value = target[prop];
    return typeof value === 'function' ? value.bind(target) : value;
  },
});
i18n.on('languageChanged', lng => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18nProxy;
